import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

type SaveAutomationRuleDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  intervalText: string;
  isPending: boolean;
  onConfirm: (enabled: boolean) => void;
};

export function SaveAutomationRuleDialog({
  open,
  onOpenChange,
  intervalText,
  isPending,
  onConfirm,
}: SaveAutomationRuleDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="dark">
        <AlertDialogHeader>
          <AlertDialogTitle>Enable this rule?</AlertDialogTitle>
          <AlertDialogDescription>{intervalText}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            type="button"
            variant="outline"
            disabled={isPending}
            onClick={() => onConfirm(false)}
          >
            Save as disabled
          </AlertDialogAction>
          <AlertDialogAction
            type="button"
            disabled={isPending}
            onClick={() => onConfirm(true)}
          >
            Enable and save
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
